import React from 'react'
import { useParams } from 'react-router-dom'
import CreateUserGroupBinding from '../../../components/CreateUserGroupBinding'
import { useApiRequest } from '../../../hooks'
import Spinner from '../../../components/Spinner'
import useGetUserData from '../../../hooks/useGetUserData'
import ContextMenu from '../../../components/ContextMenu'

export default function () {
  const { id } = useParams()
  // const [user] = useApiRequest(`users/${id}`)
  const { user, loading } = useGetUserData(id);

  if (!user) {
    return <Spinner />
  }

  return (
    <div className='container'>
      <ContextMenu renderTitle={() => <h1 className='title'>Add to group</h1>}></ContextMenu>
      <CreateUserGroupBinding user={user} />
    </div>
  )
}
